import request from "../../untils/request";

export function selectList() {

    return request({
        url: '/module/selectList',
        method: 'post',
    })
}

export function detail(param) {

    return request({
        url: '/module',
        method: 'get',
        params: param
    })
}

export function add(data) {

    return request({
        url: '/module',
        method: 'post',
        data: data
    })
}

export function remove(param) {

    return request({
        url: '/module/'+param,
        method: 'delete',
    })
}
